export default "__VITE_ASSET__BccyYpIC__"